import { useMagasinStore } from "@/store/magasin";
import { useDatalayerStore } from "@/store/datalayer";
import { usePanierStore } from "@/store/panier";
import { useUpdateCartTracking } from "@/mixins/tracking/update-cart"
import panierMapper from "@/services/panier/panier-mapper";
import apiDriveSmartliste from "@/services/http/api-drive/client/smartliste";

export const pageMonCompteMesProduitsHabituelsProps = () => ({
  smartliste: {
    type: Object,
    required: false,
    default: null
  },
  pageIsLoading: {
    type: Boolean,
    required: false,
    default: false
  }
})

export const usePageMonCompteMesProduitsHabituels = (props, context, supprimerProduitRef, productListRef) => {

  const { trackUpdateCart } = useUpdateCartTracking();

  const app = useNuxtApp();

  const magasinStore = useMagasinStore();
  const datalayerStore = useDatalayerStore();
  const panierStore = usePanierStore();

  const isLoading = ref(false);
  const produitsToDelete = ref([]);

  const { isNational } = storeToRefs(magasinStore);

  const { setStoreLocatorContext } = datalayerStore;

  const { addListeProduitsToPanier } = panierStore;

  const { displayStoreLocator } = magasinStore;

  const liste = computed(() => {
    return props.smartliste ? props.smartliste.data : null
  })
  const meta = computed(() => {
    return props.smartliste ? props.smartliste.meta : null
  })
  const noProduct = computed(() => {
    if (liste.value) {
      return liste.value.attributes.nb_produits === 0;
    }
    return true;
  })

  const addToCartListe = async () => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    }
    await addToCartProduits(liste.value.attributes.produits.data);
  }

  const deleteProduits = (produits) => {
    produitsToDelete.value = produits.map(p => { return p.id });
    supprimerProduitRef.value.show();
  }

  const confirmDeleteProduits = async () => {
    isLoading.value = true;
    try {
      await app.$apiDrive.use(apiDriveSmartliste).deleteItems(produitsToDelete.value);
      supprimerProduitRef.value.hide();
      productListRef.value.unselectAll();
      context.emit('reload');
    } finally {
      isLoading.value = false;
    }
  }

  const addToCartProduits = async (produits) => {
    if (isNational.value) {
      displayStoreLocator();
      return;
    } else {
      trackUpdateCart({
        products: produits.map(product => (
          {
            ...panierMapper.getArticleModel(product.attributes.produit.data),
            quantity: 1
          }
        )),

        method: "add",
        context: `${trackingCodes.LABELGA.AnciennesCommandes}${trackingCodes.CONTEXTPANIER.AjouterAuPanier}`
      });
    }
    await addListeProduitsToPanier(produits);
  }

  const mounted = () => {
    setStoreLocatorContext('Produits habituels')
  }

  return {
    isLoading,
    liste,
    meta,
    noProduct,
    addToCartListe,
    addToCartProduits,
    deleteProduits,
    confirmDeleteProduits,
    mounted
  }
}

